import styles from './index.module.scss';

export interface AbilityCardProps {
  title: string;
  description: string;
  image: string;
  variant?: 'small' | 'wide';
}

export default function AbilityCard({
  title,
  description,
  image,
  variant = 'small',
}: AbilityCardProps) {
  return (
    <article className={`${styles.card} ${variant === 'wide' ? styles.wide : styles.small}`}>
      <div className={styles.media}>
        <img src={image} alt={title} loading="lazy" />
      </div>
      <div className={styles.textContent}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>
    </article>
  );
}
